// @ts-check
import ChooseSettingNotice from './ChooseSettingNotice';

export default ChooseSettingNotice;
